import React from "react";

// Dependency-free carousel for crew photos
const CrewCarousel = () => {
  const images = [
    "/images/IMG_0001.jpeg",
    "/images/IMG_0002.jpeg",
    "/images/IMG_0006.jpeg",
    "/images/IMG_0009.jpeg",
    "/images/IMG_0010.jpeg",
    "/images/rv_jeep.jpeg",
  ];

  const [index, setIndex] = React.useState(0);

  const goTo = (i) => setIndex((i + images.length) % images.length);
  const prev = () => goTo(index - 1);
  const next = () => goTo(index + 1);

  const onKeyDown = (e) => {
    if (e.key === "ArrowLeft") prev();
    if (e.key === "ArrowRight") next();
  };

  return (
    <section className="about-carousel" aria-label="Lucy crew photos carousel">
      <div className="carousel" onKeyDown={onKeyDown} tabIndex={0}>
        <div className="carousel-viewport">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${index * 100}%)` }}
          >
            {images.map((src, i) => (
              <div className="carousel-item" key={i}>
                <img
                  src={src}
                  alt={`Lucy crew photo ${i + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>
        </div>

        <button className="carousel-btn prev" onClick={prev} aria-label="Previous photo">❮</button>
        <button className="carousel-btn next" onClick={next} aria-label="Next photo">❯</button>

        <div className="carousel-dots" role="tablist" aria-label="Carousel pagination">
          {images.map((_, i) => (
            <button
              key={i}
              role="tab"
              aria-selected={i === index}
              aria-label={`Go to slide ${i + 1}`}
              className={`dot ${i === index ? "active" : ""}`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const About = () => {
  return (
    <div className="about-container">
      <section className="about-header">
        <img src="/images/glucy_white.png" alt="Lucy Logo" className="lucy-logo"/>
      </section>

      <section className="about-content">
        <h3>Who We Are</h3>
        <p>
          Adventure with Lucy is all about exploring the great outdoors through sailing, RVing, and off-road adventures.
          Join us as we navigate the open waters, explore breathtaking landscapes, and share our experiences with you.
        </p>
        <br></br>
        <h3>Our Mission</h3>
        <p>
          We aim to inspire others to embrace adventure, learn new skills, and create lasting memories along the way.
        </p>
      </section>

      {/* Crew Photos Carousel */}
      <CrewCarousel />

      <style>{`
        .about-container {
          text-align: center;
          padding: 50px 20px;
        }
        .about-header {
          // background: #f4f4f4;
          background: url('/images/lucy_slip.jpeg') center/cover no-repeat;
          padding: 40px 20px;
          // text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.7);
        }
        .about-content {
          margin-top: 40px;
          padding: 20px;
        }
        .lucy-logo {
          width: 600px;
          max-width: 80%;
          margin-bottom: 20px;
          filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.6));
        }
        .about-carousel {
          margin-top: 28px;
        }
        .carousel {
          position: relative;
          max-width: 1100px;
          margin: 0 auto;
          outline: none;
        }
        .carousel-viewport {
          overflow: hidden;
          border-radius: 12px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.15);
        }
        .carousel-track {
          display: flex;
          width: 100%;
          transition: transform 400ms ease;
        }
        @media (prefers-reduced-motion: reduce) {
          .carousel-track { transition: none; }
        }
        .carousel-item {
          min-width: 100%;
          // height: 340px;
          height: clamp(280px, 45vw, 520px); /* responsive taller frame */
        }
        @media (max-width: 600px) {
          .carousel-item { height: 240px; }
        }
        .carousel-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }
        .carousel-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background: rgba(0,0,0,0.45);
          color: #fff;
          border: none;
          padding: 10px 12px;
          border-radius: 999px;
          cursor: pointer;
          backdrop-filter: blur(2px);
        }
        .carousel-btn:hover { background: rgba(0,0,0,0.6); }
        .carousel-btn.prev { left: 10px; }
        .carousel-btn.next { right: 10px; }
        .carousel-dots {
          display: flex;
          justify-content: center;
          gap: 8px;
          margin-top: 10px;
        }
        .dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #c8c8c8;
          border: none;
          cursor: pointer;
        }
        .dot.active { background: #555; }
      `}</style>
    </div>
  );
};

export default About;
